"use client";
import { jsx as w } from "react/jsx-runtime";
import { cva as x } from "class-variance-authority";
import { forwardRef as b, useState as v, useRef as y, useEffect as z } from "react";
import { cn as s } from "../../../utils/utils.mjs";
import { getAccessibleFocusStyles as E } from "../../../utils/styles.mjs";
const R = x(
  `
    block
    w-full
    rounded-md
    transition-colors
    placeholder:transition-colors
    disabled:cursor-not-allowed
    disabled:opacity-60
    `,
  {
    variants: {
      tone: {
        dark: "bg-gray-925 text-white placeholder:text-gray-400 border-gray-700",
        light: "bg-white text-gray-900 placeholder:text-gray-500 border-gray-300"
      },
      size: {
        sm: "text-sm leading-5 px-3 py-2 min-h-20 min-w-64",
        md: "text-base leading-6 px-4 py-3 min-h-24 min-w-72",
        lg: "text-base leading-6 px-4 py-4 min-h-32 min-w-80"
      },
      resize: {
        vertical: "resize-y",
        horizontal: "resize-x",
        all: "resize",
        none: "resize-none"
      }
    },
    defaultVariants: {
      tone: "light",
      size: "md",
      resize: "vertical"
    }
  }
), A = b(
  ({ className: i, size: a = "md", tone: l = "light", resize: c = "vertical", keyboardFocusOnly: e = !1, ...u }, d) => {
    const [m, n] = v(!1), t = y("mouse");
    z(() => {
      if (!e) return;
      const o = () => {
        t.current = "mouse";
      }, r = (p) => {
        p.key === "Tab" && (t.current = "keyboard");
      };
      return document.addEventListener("mousedown", o), document.addEventListener("keydown", r), () => {
        document.removeEventListener("mousedown", o), document.removeEventListener("keydown", r);
      };
    }, [e]);
    const f = () => {
      e && t.current === "keyboard" && n(!0);
    }, g = () => {
      e && n(!1);
    }, h = e ? s(
      "focus:outline-none focus:ring-0 focus:border-none",
      "focus-visible:outline-none focus-visible:ring-0 focus-visible:border-none",
      m && "!outline-solid !outline-2 !outline-offset-2 !outline-white !ring-2 !ring-blue-600"
    ) : E();
    return /* @__PURE__ */ w(
      "textarea",
      {
        ref: d,
        className: s(R({ size: a, tone: l, resize: c }), h, i),
        onFocus: f,
        onBlur: g,
        ...u
      }
    );
  }
);
A.displayName = "TextAreaInput";
export {
  A as TextAreaInput
};
